import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProfileStatisticsTopScorerCard from "./profileStatisticsTopScorerCard";
import "../../../assets/css/scss/section/_profileStatisticsTopScorer.scss";

export default function ProfileStatisticsTopScorer(props: any) {
  let defaultImage = "https://lcd-images-public.s3.ap-south-1.amazonaws.com/user_profiles/default-user-profile-image.png"
  const filterData: any[] = []
  props?.topperDetails?.forEach((item) => {
    if (item.length) {
      filterData.push(item)
    }
  })
  return (
    <div className="theme-light-white player-details">
      <Container>
        <Row>
          {filterData?.map((item: any, index) => {
            if (item && Array.isArray(item) && item.length) {
              let dataDetail = { ...item[0] }
              const finalData: any = {}
              if (Object.keys(dataDetail).length && index < 4) {
                for (const property in dataDetail) {
                  if (property === "player_image" || property === "identifier" || property === "player_name" || property === "player_position") {
                    if (property === "player_image") {
                      if (dataDetail[property]) {
                        finalData[property] = dataDetail[property]
                      } else {
                        finalData[property] = defaultImage
                      }
                    } else {
                      finalData[property] = dataDetail[property]
                    }
                  } else {
                    finalData['display_field'] = property;
                    finalData['display_value'] = dataDetail[property];
                  }
                }
                return <Col md={4} lg={3} className="mb-4 mb-lg-2">
                  <ProfileStatisticsTopScorerCard {...finalData} />
                </Col>
              } else {
                return null
              }
            } else {
              return null;
            }
          })}
          {/* <Col md={4} lg={3} className="mb-4 mb-lg-0">
            <ProfileStatisticsTopScorerCard />
          </Col>
          <Col md={4} lg={3} className="mb-4 mb-lg-0">
            <ProfileStatisticsTopScorerCard />
          </Col>
          <Col md={4} lg={3} className="mb-4 mb-lg-0">
            <ProfileStatisticsTopScorerCard />
          </Col>
          <Col md={4} lg={3} className="mb-4 mb-lg-0">
            <ProfileStatisticsTopScorerCard />
          </Col> */}
        </Row>
      </Container>
    </div>
  );
}
